/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { useMediaQuery } from '@mui/material';
import { useMemo } from 'react';
import { getTheme } from '../../styles';
import { useUserPreferences } from './UserPreferencesContext';

/** Settings › Appearance › Reduce motion, where `system` follows the OS setting. */
export const usePrefersReducedMotion = () => {
  const { reduceMotion } = useUserPreferences().preferences.appearance;
  const osPrefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)', {
    noSsr: true,
  });
  return reduceMotion === 'on' || (reduceMotion === 'system' && osPrefersReducedMotion);
};

export const usePreferredTheme = () => {
  const { theme: themePreference, accent } = useUserPreferences().preferences.appearance;
  const osPrefersDark = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true });
  const osMode = osPrefersDark ? 'dark' : 'light';
  const mode = themePreference === 'system' ? osMode : themePreference;
  const theme = useMemo(() => getTheme(mode, accent), [accent, mode]);
  return { theme, reduceMotion: usePrefersReducedMotion() };
};
